import { useContext, useEffect, useState } from "react";

// importing styles
import styles from "./CartCheckout.module.scss";

// importing components
import { Col, Row, message } from "antd";
import CartScreen from "../../Components/CartScreen/CartScreen";
import ConfirmationScreen from "../../Components/ConfirmationScreen/ConfirmationScreen";
import Layout from "../../Components/Layout/Layout";
import PaymentScreen from "../../Components/PaymentScreen/PaymentScreen";
import ShippingAddressScreen from "../../Components/ShippingAddressScreen/ShippingAddressScreen";

// importing icons
import PaymentMethodScreen from "../../Components/PaymentMethodScreen/PaymentMethodScreen";
import { AuthContext } from "../../Contexts/AuthContext";
import { CartContext } from "../../Contexts/CartContext";
import axios from "../../config/axios";
import { Link } from "react-router-dom";
import {
  BestSellingProducts,
  LifeChangeSlider,
  RecommendedProducts,
} from "../LandingV2/LandingV2";
import { BsArrowLeftShort } from "react-icons/bs";
import { CartCheckoutBreadCrumb } from "./components/CartCheckoutBreadCrumb";
import { CartCheckoutStepper } from "./components/CartCheckoutStepper";
import { CartCheckoutEmptyState } from "./components/CartCheckoutEmptyState";

const CartCheckout = () => {
  const { cartItems } = useContext(CartContext);
  const cartContext = useContext(CartContext);
  const { isAuthenticated, user } = useContext(AuthContext);

  const [payload, setPayload] = useState({});
  const [step, setStep] = useState(1);
  const [order, setOrder] = useState(null);
  const [stripeData, setStripeData] = useState(null);

  const [personal, setPersonal] = useState({});
  const [shipping, setShipping] = useState({});
  const [additional, setAdditional] = useState({});
  // the delivery date the customer picked, kept across a page reload the same
  // way the address steps are
  const [deliveryDate, setDeliveryDate] = useState(
    () => sessionStorage.getItem("delivery_date") || null,
  );

  const changeDeliveryDate = (date) => {
    setDeliveryDate(date);
    if (date) {
      sessionStorage.setItem("delivery_date", date);
    } else {
      sessionStorage.removeItem("delivery_date");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelector("body").scrollTo(0, 0);
  }, [step]);

  const orderPlaceHandler = () => {
    let final_payload = payload;

    let final_order_items = [];
    cartItems.forEach((item) => {
      item.order_time_price = parseFloat(item.order_time_price).toFixed(2);
      final_order_items.push(item);
    });

    final_payload.title = shipping.title ? shipping.title : user.s_title;
    final_payload.first_name = shipping.first_name
      ? shipping.first_name
      : user.s_first_name;
    final_payload.last_name = shipping.last_name
      ? shipping.last_name
      : user.s_last_name;
    final_payload.email = shipping.email ? shipping.email : user.s_email;
    final_payload.phone_number = shipping.phone_number
      ? shipping.phone_number
      : user.s_phone_number;
    final_payload.street_address = shipping.street_address
      ? shipping.street_address
      : user.s_street_address;
    final_payload.house_no = shipping.house_no
      ? shipping.house_no
      : user.s_house_no;
    final_payload.zip_code = shipping.zip_code
      ? shipping.zip_code
      : user.s_zip_code;
    final_payload.city = shipping.city ? shipping.city : user.s_city;
    final_payload.state = shipping.state ? shipping.state : user.s_state;
    final_payload.country = shipping.country ? shipping.country : "germany";
    final_payload.additional_info_1 = additional.additional_info_1
      ? additional.additional_info_1
      : user.additional_info_1;
    final_payload.additional_info_2 = additional.additional_info_2
      ? additional.additional_info_2
      : user.additional_info_2;

    //billing info
    final_payload.billing_info = JSON.stringify(personal);

    final_payload.order_items = final_order_items;
    final_payload.total = cartContext.calculateOrderTotal();
    final_payload.order_items = cartContext.cartItems;
    final_payload.payment_method = cartContext.paymentMethod;
    final_payload.delivery_method = cartContext.deliveryMethod;
    final_payload.delivery_fee = cartContext.deliveryCharge;
    final_payload.customer = isAuthenticated ? user.id : null;
    final_payload.vat_a = parseFloat(cartContext.calculateVatA()).toFixed(2);
    final_payload.vat_b = parseFloat(cartContext.calculateVatB()).toFixed(2);
    final_payload.rp_discount = cartContext.rpDiscount
      ? parseFloat(cartContext.rpDiscount).toFixed(2)
      : null;
    final_payload.rp_reward = cartContext.calculateRewardPoints();
    final_payload.delivery_date = deliveryDate;

    axios
      .post("/orders/place", final_payload)
      .then((response) => {
        setOrder(response.data.order);
        setStripeData(response.data.stripe);
        setStep(5);
      })
      .catch((error) => {
        const msg = error?.response?.data?.msg;

        // the delivery day can fill up while the customer is checking out, and
        // the only way out of that is picking another date back on step 2
        if (typeof msg === "string") {
          message.error(msg);
          if (msg.toLowerCase().includes("delivery date")) {
            changeDeliveryDate(null);
            setStep(2);
          }
          return;
        }

        message.error("We could not place your order, please try again.");
      });
  };

  const steps = [
    {
      title: "My Cart",
      pageTitle: "Shipping Cart",
      image: "https://desi-fresh.b-cdn.net/misc/cart.svg",
    },
    {
      title: "Shipping Address",
      pageTitle: "Shipping Address",
      image: "https://desi-fresh.b-cdn.net/misc/map-pin.svg",
    },
    {
      title: "Payment Method",
      pageTitle: "Payment Method",
      image: "https://desi-fresh.b-cdn.net/misc/credit-card.svg",
    },
    {
      title: "Review  & Confirm",
      pageTitle: "Review & Confirm",
      image: "https://desi-fresh.b-cdn.net/misc/review-and-confirm.svg",
    },
    {
      title: "Confirmation",
      pageTitle: "Confirmation",
      image: "https://desi-fresh.b-cdn.net/misc/check-circle.svg",
    },
  ];

  const renderCartCheckoutStepIcon = (step) => {
    return (
      <>
        {step === 1 ? (
          <img src="/icon/checkout/co_1.svg" alt="" />
        ) : step === 2 ? (
          <img src="/icon/checkout/co_2.svg" alt="" />
        ) : step === 3 ? (
          <img src="/icon/checkout/co_3.svg" alt="" />
        ) : step === 4 ? (
          <img src="/icon/checkout/co_4.svg" alt="" />
        ) : null}
      </>
    );
  };

  const renderActiveCheckoutStep = (step) => {
    switch (step) {
      case 1:
        return (
          <CartScreen
            step={step}
            setStep={setStep}
            orderPlaceHandler={orderPlaceHandler}
            setShipping={setShipping}
            setPersonal={setPersonal}
          />
        );
      case 2:
        return (
          <ShippingAddressScreen
            step={step}
            setStep={setStep}
            setPayload={setPayload}
            setStripeData={setStripeData}
            setPersonal={setPersonal}
            setShipping={setShipping}
            setAdditional={setAdditional}
            deliveryDate={deliveryDate}
            setDeliveryDate={changeDeliveryDate}
          />
        );
      case 3:
        return <PaymentMethodScreen step={step} setStep={setStep} />;
      case 4:
        return (
          <ConfirmationScreen
            personal={personal}
            shipping={shipping}
            step={step}
            payload={payload}
            setOrder={setOrder}
            setStripeData={setStripeData}
            setStep={setStep}
            deliveryDate={deliveryDate}
            orderPlaceHandler={orderPlaceHandler}
          />
        );
      case 5:
        return (
          <PaymentScreen
            step={step}
            setStep={setStep}
            stripeData={stripeData}
            order={order}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Layout
      hidePreFooter={true}
      hideFooter={true}
      disableChat={true}
      hideNewsletter={true}
    >
      {cartItems.length > 0 ? (
        <div className={styles.cart_checkout_wrapper + " dtr"}>
          <CartCheckoutBreadCrumb step={step} />
          <div className={styles.header}>
            <div className={styles.header__icon + " dt_only"}>
              {renderCartCheckoutStepIcon(step)}
            </div>
            <h2>{steps[step - 1]?.pageTitle}</h2>

            {step === 1 && (
              <Link
                to={"/"}
                style={{ display: "flex", alignItems: "center" }}
                className={"mb_only"}
              >
                <BsArrowLeftShort size={25} />
                <span style={{ borderBottom: "1px solid grey" }}>
                  Continue shopping
                </span>
              </Link>
            )}
          </div>

          {/* desktop stepper */}
          <Row>
            <Col lg={24} xs={0}>
              <div className={styles.steps_wrapper}>
                <CartCheckoutStepper
                  steps={steps}
                  activeStep={step - 1}
                  setActiveStep={setStep}
                />
              </div>
            </Col>
          </Row>

          {renderActiveCheckoutStep(step)}
        </div>
      ) : (
        <div className={"container"}>
          <CartCheckoutEmptyState isAuthenticated={isAuthenticated} />

          <br />
          <LifeChangeSlider />

          <br />
          <RecommendedProducts />

          <br />
          <BestSellingProducts />
        </div>
      )}
    </Layout>
  );
};

export default CartCheckout;
